/* src/app/app.component.scss */
#menu {
  height: 100%;
}
.material-icon {
  font-family: "Material Symbols Outlined" !important;
  font-size: 30px;
  color: white;
}
/*# sourceMappingURL=app.component.css.map */
